var m = require('mithril');
var loaders = require('./loaders');

var auditMonitor = {};

auditMonitor.count = 0;
auditMonitor.requestCount = 0;
auditMonitor.requestPromise = null;

auditMonitor.getCount = function () {
  if (auditMonitor.requestPromise) return auditMonitor.requestPromise;
  if (auditMonitor.requestCount > 0) return Promise.resolve(auditMonitor.count);
  return auditMonitor.requestCountSummary();
};

auditMonitor.requestCountSummary = function () {
  if (auditMonitor.requestPromise) return auditMonitor.requestPromise;
  auditMonitor.requestCount++;
  auditMonitor.requestPromise = loaders.requestWithLoader({
    loader: 'background',
    method: 'GET',
    url: '/api/v1/audit/count'
  })
  .then(function (response) {
    auditMonitor.count = Number(response && response.count ? response.count : 0);
    m.redraw();
    return auditMonitor.count;
  })
  .catch(function (err) {
    console.error('Failed to load audit resource count', err);
    return auditMonitor.count;
  })
  .finally(function () {
    auditMonitor.requestPromise = null;
  });
  return auditMonitor.requestPromise;
};

module.exports = auditMonitor;
